import { Col, Row } from "react-grid-system";
import IAttribute from "../../../../models/IAttribute";
import IAttributesFieldListProps from "./IAttributesFieldListProps";
import { Button, Table, TableBody, TableCell, TableCellLayout, TableRow } from "@fluentui/react-components";
import { Delete16Filled } from "@fluentui/react-icons";
import { mergeStyles } from "@fluentui/merge-styles";
import useStyleUtils from "../../../../utilities/styles";

export default function AttributesList(props: IAttributesFieldListProps) {
    const style = useStyleUtils();
    
    const btnRemoveStlyes = mergeStyles({ color: "red" });
    const btnRemoveClassName = mergeStyles(style.mr2, btnRemoveStlyes);

    return (
        <Row>
            <Col>
                <Table>
                    <TableBody>
                        {
                            props.attributes.map((attribute: IAttribute, index: number) => (
                                <TableRow>
                                    <TableCell>
                                        <TableCellLayout appearance="primary">
                                            {attribute.name}
                                        </TableCellLayout>
                                    </TableCell>
                                    <TableCell>
                                        <TableCellLayout>
                                            {attribute.value}
                                        </TableCellLayout>
                                    </TableCell>
                                    <TableCell>
                                        <TableCellLayout>
                                            <Button
                                                size="small"
                                                appearance="subtle"
                                                icon={<Delete16Filled />}
                                                className={btnRemoveClassName}
                                                onClick={() => props.onRemove(index)}
                                                />
                                        </TableCellLayout>
                                    </TableCell>
                                </TableRow>
                            ))
                        }
                    </TableBody>
                </Table>
            </Col>
        </Row>
    );
}